import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's145g-s145m02',
    templateUrl: './s145g-s145m02.component.html'
})
export class S145gS145m02Component extends Overlay {
    scrndt2: any = {};
    scrntm2: any = {};
    pagenbr: any = {};
    pagecnt: any = {};
    head01: any = {};
    head02: any = {};
    line01: any = {};
    line02: any = {};
    line03: any = {};
    line04: any = {};
    line05: any = {};
    line06: any = {};
    line07: any = {};
    line08: any = {};
    line09: any = {};
    line10: any = {};
    line11: any = {};
    line12: any = {};
    line13: any = {};
    line14: any = {};
    line15: any = {};
    line16: any = {};
    msgln2: any = {};
    frstkey: any = {};
    scndkey: any = {};

    public FIELDS: string[] = ['scrndt2', 'scrntm2', 'pagenbr', 'pagecnt', 'head01', 'head02', 'line01', 'line02', 'line03', 'line04', 'line05', 'line06', 'line07', 'line08', 'line09', 'line10', 'line11', 'line12', 'line13', 'line14', 'line15', 'line16', 'msgln2', 'frstkey', 'scndkey'];
    public LINES: number[] = [1, 2, 3, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];

    ngAfterViewInit(): void {
    }
}
